import { loginByCaptcha,loginOut } from '@/api'
import { loginByPassword as loginByPasswordApi } from '@/api'

const state = {
  // 用户信息
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
  // 登录状态
  isLogin: !!localStorage.getItem('token'),
  // token
  token: localStorage.getItem('token') || '',
  // 用户ID
  userId: localStorage.getItem('userId') || ''
}

const mutations = {
  // 设置用户信息
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  
  // 设置登录状态
  SET_LOGIN_STATE(state, isLogin) {
    state.isLogin = isLogin
  },
  
  // 设置token
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  
  // 设置用户ID
  SET_USER_ID(state, userId) {
    state.userId = userId
    if (userId) {
      localStorage.setItem('userId', userId)
    } else {
      localStorage.removeItem('userId')
    }
  },
  
  // 清除用户信息
  CLEAR_USER_INFO(state) {
    state.userInfo = {}
    state.isLogin = false
    state.token = ''
    state.userId = ''
    localStorage.removeItem('userInfo')
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
  }
}

const actions = {
  // 登录
  async login({ commit }, loginData) {
    try {
      const response = await loginByCaptcha(loginData)
      const { data } = response
      
      if (data) {
        commit('SET_TOKEN', data)
        commit('SET_LOGIN_STATE', true)
        return {
          success: true,
          message: '登录成功'
        }
      } else {
        return {
          success: false,
          message: '登录失败，请检查验证码'
        }
      }
    } catch (error) {
      console.error('登录失败:', error)
      return {
        success: false,
        message: error.message || '登录失败，请稍后重试'
      }
    }
  },
  // 账号密码登录
  async loginByPassword({ commit }, { loginName, password }) {
    try {
      const response = await loginByPasswordApi({ loginName, password })
      const { data } = response
      if (data) {
        commit('SET_TOKEN', data)
        commit('SET_LOGIN_STATE', true)
        return {
          success: true,
          message: '登录成功'
        }
      } else {
        return {
          success: false,
          message: '登录失败，请检查账号或密码'
        }
      }
    } catch (error) {
      console.error('账号密码登录失败:', error)
      return {
        success: false,
        message: error.message || '登录失败，请稍后重试'
      }
    }
  },
  
  // 登出
  async logout({ commit }) {
    const result = await loginOut()
    if (result.code === 200) {
      commit('CLEAR_USER_INFO')
      return {
        success: true,
        message: '已退出登录'
      }
    } else {
      return {
        success: false,
        message: '退出登录失败'
      }
    }
  },
  
  // 更新用户信息
  updateUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
  },
  
  // 检查登录状态
  checkLoginStatus({ commit, state }) {
    const token = localStorage.getItem('token')
   
    if (token) {
      commit('SET_LOGIN_STATE', true)
      commit('SET_TOKEN', token)
      return true
    } else {
      commit('CLEAR_USER_INFO')
      return false
    }
  },
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
    
  }
}

const getters = {
  // 获取用户信息
  userInfo: state => state.userInfo,
  
  // 获取登录状态
  isLogin: state => state.isLogin,
  
  // 获取token
  token: state => state.token,
  
}

export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
} 


// WEBPACK FOOTER //
// ./src/store/modules/user.js